import { jsx as p } from "react/jsx-runtime";
import { useId as m } from "react";
import { r as g } from "./chunks/resolveConfig-BryMA7OT.js";
import u from "./preset.js";
import { S as f } from "./chunks/react-select.esm-BkMQbR_A.js";
const { theme: o } = g(u), b = {
  control: (r, n) => ({
    ...r,
    backgroundColor: o.colors.white,
    borderColor: o.colors.neutral[200],
    boxShadow: "none",
    cursor: "pointer",
    fontSize: o.fontSize.base,
    padding: o.spacing[1],
    transition: "none",
    ":hover": { borderColor: o.colors.neutral[200] },
    ...n.isFocused && {
      outline: `3px dotted ${o.colors.cyan[500]}`
    }
  }),
  dropdownIndicator: (r, n) => ({
    ...r,
    color: o.colors.cyan[500],
    border: "none",
    transition: "transform 300ms",
    ":hover": { color: o.colors.cyan[500] },
    ...n.selectProps.menuIsOpen && { transform: "rotate(180deg)" }
  }),
  indicatorSeparator: () => ({
    display: "none"
  }),
  menu: (r) => ({
    ...r,
    overflow: "hidden",
    zIndex: "10"
  }),
  menuPortal: (r) => ({
    ...r,
    zIndex: "10"
  }),
  menuList: (r) => ({
    ...r,
    padding: 0
  }),
  option: (r, n) => ({
    ...r,
    cursor: "pointer",
    fontFamily: o.fontFamily.secondary,
    padding: `${o.spacing[2]} ${o.spacing[4]}`,
    ":active": {
      backgroundColor: o.colors.gray[100]
    },
    ...n.isSelected && {
      backgroundColor: "none",
      borderLeft: `6px solid ${o.colors.blue[500]}`,
      color: "inherit",
      fontWeight: "600",
      paddingLeft: `calc(${o.spacing[4]} - 6px)`,
      ":hover": {
        backgroundColor: o.colors.gray[100]
      }
    },
    ...n.isFocused && {
      backgroundColor: o.colors.gray[100]
    }
  })
}, v = ({
  ariaLabel: r,
  className: n,
  isClearable: s,
  onChange: a,
  options: t = [],
  placeholder: c,
  value: i
}) => {
  const l = m(), d = t.find((e) => e.value === i);
  return /* @__PURE__ */ p(
    f,
    {
      "aria-label": r,
      classNames: { container: () => n },
      instanceId: l,
      isClearable: s,
      isSearchable: !1,
      onChange: (e) => a && a((e == null ? void 0 : e.value) || ""),
      options: t,
      placeholder: c,
      styles: b,
      value: d
    }
  );
};
export {
  v as default
};
